module.exports = __webpack_public_path__ + "assets/SquareInSquare.9301cccb3d4f935020275c0cb20e3c60.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/SquareInSquare.gmt
// module id = 1002
// module chunks = 0